(() => {
  if (window.cardclubMarketContextStarted) return;
  window.cardclubMarketContextStarted = true;
  const context = document.querySelector('#cc-market-context');
  let market;
  try { market = JSON.parse(context.textContent); } catch { return; }
  if (!/^[A-Z]{2}$/.test(market.countryCode) || !['USD', 'GBP', 'EUR'].includes(market.currencyCode)) return;
  // Display only: retain Liquid amounts, locale separators and component binding attributes.
  const moneyScope = '[data-cc-market-money], .price, .compare-at-price, .price-item__group, .unit-price, .cart-items__unit-price-wrapper, .cart-items__price, .cart-items__price-unit, .cart-items__table caption, .cart-totals__original-value, .cart-totals__total-value, .cart-discounts__value, [ref="facetStatus"], .price-facet__highest-price';
  const excluded = 'script, style, template, noscript, input, select, option, textarea, [contenteditable]:not([contenteditable="false"]), pre, code, kbd, samp, svg, math, [data-cc-money-ignore]';
  const space = '[ \\u00a0\\u202f]';
  const token = `(?:USD${space}*\\$|\\$${space}*USD|US\\$|\\$US|USD|\\$|GBP${space}*£|£${space}*GBP|GB£|£GB|GBP|£|EUR${space}*€|€${space}*EUR|EUR|€)`;
  const number = "(?:\\d{1,3}(?:[.,'’\\u00a0\\u202f ]\\d{3})+|\\d+)(?:[.,]\\d+)?";
  const moneyPattern = new RegExp(`(?<![\\p{L}\\p{N}_.,])([-−+]?)(?:(${token})${space}*([-−+]?)${space}*(${number})(?:${space}*(USD|GBP|EUR)(?![\\p{L}\\p{N}_])(?!${space}*[$£€\\d]))?|(${number})${space}*(${token})(?!${space}*\\d))(?![\\p{L}\\p{N}_])`, 'gu');
  const currencyOf = value => /EUR|€/.test(value) ? 'EUR' : /GBP|£/.test(value) ? 'GBP' : 'USD';
  const moveMoney = (match, sign, prefix, innerSign, amount, code, trailingAmount, suffix) => {
    const currency = currencyOf(prefix || suffix);
    if (code && currencyOf(code) !== currency || sign && innerSign) return match;
    sign = sign || innerSign || '';
    if (prefix) {
      // Keep already-prefixed spacing/signs intact; move only a trailing ISO code.
      if (!code) return match;
      return `${sign}${code ? code + ' ' : ''}${prefix}${/[A-Z]$/.test(prefix) ? ' ' : ''}${amount}`;
    }
    return `${sign}${suffix}${/[A-Z]$/.test(suffix) ? ' ' : ''}${trailingAmount}`;
  };
  const positionMoney = text => text.replace(moneyPattern, moveMoney);
  const writtenText = new WeakMap();
  const writeText = (node, text) => {
    if (node.nodeValue === text) return;
    node.nodeValue = text;
    writtenText.set(node, text);
  };
  const displayTexts = root => {
    const nodes = [];
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      if (!walker.currentNode.parentElement?.closest(excluded)) nodes.push(walker.currentNode);
    }
    return nodes;
  };
  const positionNativeMoney = () => {
    const visited = new Set();
    document.querySelectorAll(moneyScope).forEach(root => displayTexts(root).forEach(node => {
      if (visited.has(node)) return;
      // Liquid money wrappers may split the amount and token into inline spans.
      const wrapper = node.parentElement.closest('bdi, .money');
      const texts = wrapper && root.contains(wrapper) && !wrapper.querySelector(excluded + ', .visually-hidden, [aria-hidden="true"]') ? displayTexts(wrapper) : [node];
      let offset = 0;
      const spans = texts.map(text => {
        visited.add(text);
        const span = {node: text, start: offset, end: offset + text.nodeValue.length};
        offset = span.end;
        return span;
      });
      const edits = [];
      texts.map(text => text.nodeValue).join('').replace(moneyPattern, (...args) => {
        const label = moveMoney(...args);
        if (label !== args[0]) edits.push({start: args.at(-2), end: args.at(-2) + args[0].length, label});
        return label;
      });
      // Apply from the end so offsets remain valid; keep every element/text node.
      edits.reverse().forEach(edit => spans.forEach(span => {
        if (span.start >= edit.end || span.end <= edit.start) return;
        const from = Math.max(0, edit.start - span.start);
        const to = Math.min(span.end, edit.end) - span.start;
        writeText(span.node, span.node.nodeValue.slice(0, from) + (edit.start >= span.start ? edit.label : '') + span.node.nodeValue.slice(to));
      }));
    }));
  };
  // Scoped app/cart localization only; never touch product copy or consent state.
  const appLocale = (() => {
    const raw = (document.documentElement.lang || market.locale || 'en').toLowerCase().replace('_', '-');
    const language = raw.split('-')[0];
    return language === 'zh' ? 'zh-CN' : ['en', 'nl', 'de', 'fr', 'es', 'it'].includes(language) ? language : 'en';
  })();
  const updateCartCopy = () => {
    const copy = window.CardclubCustomUI;
    if (!copy?.t('cart.bundle_label')) return; // EN/NL/zh-CN retain their exact original copy.
    document.querySelectorAll('header-actions [data-testid="cart-drawer-trigger"], header-actions a.action__cart').forEach(node => {
      node.setAttribute('aria-label', copy.t('cart.regular_label'));
      node.setAttribute('title', copy.t('cart.regular_label'));
    });
    const directText = (node, text) => {
      if (!node || !text) return;
      const current = [...node.childNodes].find(n => n.nodeType === 3);
      if (current) writeText(current, text);
      else node.prepend(document.createTextNode(text)); // Keep existing counters, icons and listeners.
    };
    document.querySelectorAll('.cardclub-bundle-cart-entry').forEach(anchor => {
      anchor.setAttribute('aria-label', copy.t('cart.bundle_label'));
      anchor.setAttribute('title', copy.t('cart.bundle_note'));
      directText(anchor.querySelector('[data-cc-bundle-cart-short]') || anchor.querySelector(':scope > span:first-child'), copy.t('cart.bundle_short'));
      directText(anchor.querySelector('[data-cc-bundle-cart-note]') || anchor.querySelector(':scope > .visually-hidden'), ' — ' + copy.t('cart.bundle_note'));
    });
  };
  const apply = () => {
    updateCartCopy();
    document.querySelectorAll('[data-cc-market-money]').forEach(node => {
      if (node.closest(excluded)) return;
      const minor = Number(node.getAttribute('data-cc-market-money'));
      if (!Number.isSafeInteger(minor) || minor < 0 || minor > 1000000) return;
      const label = positionMoney(new Intl.NumberFormat(market.locale || 'en', {style:'currency', currency:market.currencyCode, minimumFractionDigits:minor % 100 ? 2 : 0, maximumFractionDigits:minor % 100 ? 2 : 0}).format(minor / 100));
      const texts = displayTexts(node).filter(text => text.nodeValue.trim() && !text.parentElement.closest('.visually-hidden, [aria-hidden="true"], button'));
      if (texts.length === 1) writeText(texts[0], label);
      else if (!node.childNodes.length) node.append(document.createTextNode(label));
      if (node.getAttribute('data-cc-currency') !== market.currencyCode) node.setAttribute('data-cc-currency', market.currencyCode);
    });
    positionNativeMoney();
    document.querySelectorAll('a[href*="/apps/cardclub-bundles"]').forEach(anchor => {
      let url;
      try { url = new URL(anchor.href, location.href); } catch { return; }
      if (url.origin !== location.origin || !/^\/apps\/cardclub-bundles(?:\/|$)/.test(url.pathname)) return;
      url.searchParams.set('country', market.countryCode);
      if (!url.searchParams.get('locale')) url.searchParams.set('locale', appLocale);
      if (anchor.href !== url.href) anchor.href = url.href;
    });
  };
  apply();
  let scheduled = false;
  new MutationObserver(records => {
    if (scheduled || !records.some(record => {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (!target || target.closest(excluded)) return false;
      if (record.type === 'characterData' && writtenText.get(record.target) === record.target.nodeValue) return false;
      if (record.type === 'attributes') return target.matches('a[href*="/apps/cardclub-bundles"], [data-cc-market-money]');
      return target.closest(moneyScope + ', .cardclub-bundle-cart-entry') || [...record.addedNodes].some(node => node.nodeType === 1);
    })) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; apply(); });
  }).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['href', 'data-cc-market-money'], characterData:true});
  document.addEventListener('shopify:section:load', apply);
})();
